import { jsxs, jsx } from "react/jsx-runtime";
import { useRicosTheme, getHeaderAndParagraphCustomStylesWUT } from "../../../theme/ricos-theme-utils.js";
import RicosViewer from "../../../ui/ricos-viewer/ricos-viewer.js";
import { ToggleTruncateButtonWUT } from "../../../ui/ricos-viewer/toggle-truncate-button-wut.js";
import { useTruncateRicosContent } from "../../../ui/ricos-viewer/use-truncate-ricos-content.js";
const RICOS_THEME = {
  customStyles: getHeaderAndParagraphCustomStylesWUT()
};
const RichTextWUT = ({
  content,
  maxShownParagraphs,
  id,
  FieldLayout
}) => {
  const customTheme = useRicosTheme(RICOS_THEME);
  const {
    displayedContent,
    isTruncated,
    isTruncateButtonShown,
    toggleTruncate
  } = useTruncateRicosContent(content, maxShownParagraphs);
  return /* @__PURE__ */ jsxs(FieldLayout, { fieldId: id, children: [
    /* @__PURE__ */ jsx(RicosViewer, { content: displayedContent, customTheme }),
    isTruncateButtonShown && /* @__PURE__ */ jsx(
      ToggleTruncateButtonWUT,
      {
        isTruncated,
        onClick: toggleTruncate
      }
    )
  ] });
};
export {
  RichTextWUT
};
//# sourceMappingURL=rich-text-wut.js.map
